// import React, { useEffect, useState } from 'react';
// import { motion } from 'framer-motion';
// // import Mayabg from "../assets/mayabg.webp"; // Your background images
// import Mayabg from "../assets/fest_front_banner.jpg"; // Your background images
// import Mayabg1 from "../assets/fest_front_banner.jpg"; // Your background images
// import Mayabg2 from "../assets/fest_front_banner.jpg"; // Your background images
// // import SecondImage from "../assets/mayabg.webp"; // Replace with your second image path
// // import ThirdImage from "../assets/mayabg.webp"; // Replace with your third image path
// import { Navigate } from 'react-router-dom';

// const HeroSection = () => {
//   const backgrounds = [
//     Mayabg,
//     Mayabg1,
//     Mayabg2,
//     // SecondImage,
//     // ThirdImage,
//   ];

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [isFirstImageLoaded, setIsFirstImageLoaded] = useState(false);

//   useEffect(() => {
//     const preloadLink = document.createElement('link');
//     preloadLink.rel = 'preload';
//     preloadLink.as = 'image';
//     preloadLink.href = backgrounds[0];
//     document.head.appendChild(preloadLink);

//     return () => {
//       document.head.removeChild(preloadLink);
//     };
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => (prevIndex + 1) % backgrounds.length);
//     }, 5000); // Change image every 5 seconds

//     return () => clearInterval(interval);
//   }, [backgrounds.length]);

//   return (
//     <div className="w-full h-screen font-opensans relative z-0 mt-20">
//       <div className="relative w-full h-full overflow-hidden">
//         <motion.img
//           src={backgrounds[currentImageIndex]}
//           className="w-full h-full object-cover"
//           alt={`Background ${currentImageIndex + 1}`}
//           priority={currentImageIndex === 0}
//           loading={currentImageIndex === 0 ? 'eager' : 'lazy'}
//           decoding="async"
//           initial={{ scale: 1, filter: 'blur(20px)' }}
//           animate={{ 
//             scale: 1.7,
//             filter: 'blur(0px)',
//           }}
//           transition={{ 
//             scale: { duration: 7 },
//             filter: { duration: 0.5 }
//           }}
//           onLoad={(e) => {
//             e.target.style.filter = 'none';
//             if (currentImageIndex === 0) {
//               setIsFirstImageLoaded(true);
//             }
//           }}
//         />
//         <div className="absolute inset-0 bg-black opacity-30"></div> {/* Dark overlay for better text visibility */}

//         <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
//           <motion.p 
//             initial={{ opacity: 0, y: 50 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 1.5 }}
//             className="text-white text-2xl md:text-5xl font-bold uppercase mb-8"
//           >
//             Discover Your Future With Us
//           </motion.p>

//           <div className="flex flex-col md:flex-row gap-4">
//             <motion.button
//               initial={{ opacity: 0, y: 50 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 1.5, delay: 0.2 }}
//               className="bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 px-6 py-3 text-black rounded-full font-semibold hover:from-yellow-300 hover:to-amber-400 transition-colors"
//               onClick={() => window.location.href = 'https://admission.maya.edu.in/'}
//             >
//               Apply Now
//             </motion.button>

//             {/* <motion.button
//               initial={{ opacity: 0, y: 50 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 1.5, delay: 0.4 }}
//               className="bg-white px-6 py-3 text-black rounded-full font-semibold hover:bg-gray-100 transition-colors"
//             >
//               Explore Programs
//             </motion.button> */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HeroSection;

import React, { useState, useEffect } from 'react';

// Desktop images
import Mayabg1 from "../assets/slider/web (1).webp";
import Mayabg2 from "../assets/slider/web (2).webp";
import Mayabg3 from "../assets/slider/web (3).webp";
import Mayabg4 from "../assets/slider/web (4).webp";

// Mobile images
import Mayabg_mb1 from "../assets/slider/mob (1).webp";
import Mayabg_mb2 from "../assets/slider/mob (2).webp";
import Mayabg_mb3 from "../assets/slider/mob (3).webp";
import Mayabg_mb4 from "../assets/slider/mob (4).webp";

const HeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const desktopImages = [Mayabg1, Mayabg2, Mayabg3, Mayabg4];
  const mobileImages = [Mayabg_mb1, Mayabg_mb2, Mayabg_mb3, Mayabg_mb4];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % desktopImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const currentImage = isMobile ? mobileImages[currentIndex] : desktopImages[currentIndex];

  return (
    <div className="w-full font-opensans relative z-0 md:mt-[130px] mt-[80px]">
      <div className="relative w-full bg-gradient-to-r from-purple-900 to-pink-900">
        <div className="w-full flex justify-center px-0 py-0">
          {/* Image container */}
          <div
            className={`w-full ${
              isMobile
                ? ""
                : "max-w-[1920px] aspect-[16/9]"
            } relative`}
          >
            <img
              src={currentImage}
              className={`w-full h-full ${
                isMobile ? "object-cover" : "object-contain"
              } object-center transition-transform duration-700`}
              alt="Slider image"
              loading="eager"
              decoding="async"
            />
          </div>
        </div>

        {/* Dot indicators */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
          {(isMobile ? mobileImages : desktopImages).map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full ${index === currentIndex ? 'bg-white' : 'bg-gray-400'}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
